import { render, staticRenderFns } from "./PedidosFast.vue?vue&type=template&id=209c0aaf&scoped=true"
import script from "./PedidosFast.vue?vue&type=script&lang=js"
export * from "./PedidosFast.vue?vue&type=script&lang=js"
import style0 from "./PedidosFast.vue?vue&type=style&index=0&id=209c0aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c0aaf",
  null
  
)

export default component.exports